export default {
  'software.poweredBy': 'Energizado por',
  'copyright': 'Derechos de Autor',
  'allRightsReserved': 'Reservados todos los derechos',
};